import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Hero } from "./components/Hero/Hero"
import { List } from "./components/List/List"

const IndexesAndRatings: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout
      description={t("indexes-and-ratings.Hero.Text")}
      headerTheme="onDark"
      title={t("page.indexes-and-ratings")}
    >
      <Hero />
      <List />
    </Layout>
  )
}

export default IndexesAndRatings
